module.exports = __webpack_public_path__ + "img/cp_12.baf86159.png";